// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"567c8d50","455":"ff3b1a72","977":"ce50656f"}[chunkId] + ".chunk.js";
};